import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideAppInitializer, provideZonelessChangeDetection, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { AppPreset } from './core/config/app-preset';

import { routes } from './app.routes';
import { ConfigService } from './core/services/autoconfig/config.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    provideAppInitializer(() => {
      const configService = inject(ConfigService);
      return configService.loadConfig();
    }),
    provideMonacoEditor(),
    MessageService,
    ConfirmationService,
    providePrimeNG({
      theme: {
        preset: AppPreset,
        options: {
          // Modo oscuro: cambia a 'system' para seguir el OS
          darkModeSelector: '.dark-mode',
          // Evita que PrimeNG use el CSS reset global (respeta Bootstrap)
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng',
          },
        },
      },
      translation: {
        accept: 'Aceptar',
        reject: 'Rechazar',
        cancel: 'Cancelar',
        choose: 'Elegir',
        upload: 'Subir',
        addRule: 'Agregar regla',
        removeRule: 'Eliminar regla',
        apply: 'Aplicar',
        clear: 'Limpiar',
        matchAll: 'Coincidir todo',
        matchAny: 'Coincidir alguno',
        contains: 'Contiene',
        notContains: 'No contiene',
        startsWith: 'Empieza con',
        endsWith: 'Termina con',
        equals: 'Igual a',
        notEquals: 'Diferente a',
        noFilter: 'Sin filtro',
        lt: 'Menor que',
        lte: 'Menor o igual que',
        gt: 'Mayor que',
        gte: 'Mayor o igual que',
        is: 'Es',
        isNot: 'No es',
        before: 'Antes de',
        after: 'Después de',
        dateIs: 'La fecha es',
        dateIsNot: 'La fecha no es',
        dateBefore: 'La fecha es antes de',
        dateAfter: 'La fecha es después de',
        emptyMessage: 'Sin resultados',
        emptyFilterMessage: 'Sin resultados',
        // noResultsMessage: 'Sin resultados',
        selectionMessage: '{0} elementos seleccionados',
        emptySelectionMessage: 'Sin elemento seleccionado',
        searchMessage: '{0} resultados disponibles',
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        today: 'Hoy',
        weekHeader: 'Sem',
        firstDayOfWeek: 1,
        dateFormat: 'dd/mm/yy',
        weak: 'Débil',
        medium: 'Medio',
        strong: 'Fuerte',
        passwordPrompt: 'Ingrese una contraseña',
        chooseYear: 'Elegir año',
        chooseMonth: 'Elegir mes',
        chooseDate: 'Elegir fecha',
        prevDecade: 'Década anterior',
        nextDecade: 'Década siguiente',
        prevYear: 'Año anterior',
        nextYear: 'Año siguiente',
        prevMonth: 'Mes anterior',
        nextMonth: 'Mes siguiente',
        prevHour: 'Hora anterior',
        nextHour: 'Hora siguiente',
        prevMinute: 'Minuto anterior',
        nextMinute: 'Minuto siguiente',
        prevSecond: 'Segundo anterior',
        nextSecond: 'Segundo siguiente',
        am: 'AM',
        pm: 'PM',
        fileChosenMessage: 'Archivo seleccionado',
        noFileChosenMessage: 'Sin archivo seleccionado',
      },
    }),
  ],
};
